export const CHANGE_TYPE = {
  create: 'create',
  delete: 'delete',
};

export const getChangesList = (changesObj) =>
  Object.entries(changesObj).map(([id, changeType]) => ({ id, changeType }));

export const getIdsToChange = (changes, changeType) =>
  changes.filter((change) => change.changeType === changeType).map(({ id }) => id);
